import {
  InventoryTransferSchema,
  TransferItemSchema,
} from "@redotech/redo-model/inventory/inventory";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const updateInventoryTransfer = unaryRpc({
  name: "updateInventoryTransfer" as const,
  input: z.object({
    transferId: z.string(),
    receivedItems: z.array(TransferItemSchema),
    verified: z.boolean(),
  }),
  output: InventoryTransferSchema,
});
